<template>
  <div class="spaceCenter common">
    <div style="text-align: center;">
      <div class="item-box">即将支付</div>
      <div class="item-box">
        <label class="text-color-orange">{{totalAmt|splitK}} 元</label>
      </div>
      <div class="item-box">
        <label>接收方：</label>{{modalData.recPersonInfo.cstNm}}
      </div>
      <a-input type="password" v-model="txnPwd" class="item-input" placeholder="交易密码"/>
      <div class="spaceCenter model-footer-btns">
        <a-button class="btn-blue-line btn-big" @click="modalCancel">取消</a-button>
        <a-button
          class="btn-big"
          type="primary"
          @click="modalOk"
          :loading="modalLoad"
          :disabled="!txnPwd"
        >确定</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { verifyTradePassword,payApi } from "@/api/gold.js";
export default {
  props: ["modalData"],
  name: "goldPayModal",
  data() {
    return {
      modalLoad: false,
      txnPwd: ""
    };
  },
  computed: {
      totalAmt(){
          let list = this.modalData.list || [];
          let sum = 0;
          list.forEach(i => sum += Number(i.payAmt));
          return sum;
      }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    modalOk(e) {
      this.modalLoad = true;
      let params = { tradePassword: this.txnPwd };
      verifyTradePassword(params)
        .then((res) => {
            let p = {
                gldListStr:JSON.stringify(this.modalData.list),
                txnPwd:this.utils.getPasswordEncryptString(this.txnPwd),
                recPersonInfo:JSON.stringify(this.modalData.recPersonInfo)
            };
            this.pay(p);

        })
        .catch((error) => {
            this.modalLoad = false;
            this.$emit("error", error);
        });
    },
    pay(params){
        payApi(params)
        .then((res) => {
            this.modalLoad = false;
            this.$emit("ok", res.data);
        })
        .catch((error) => {
            this.modalLoad = false;
            this.$emit("error", error);
        });
    },
    modalCancel(e) {
      this.modalLoad = false;
      this.$emit("cancel");
    }
  }
};
</script>
<style scoped>
    .item-box > label {
        min-width: 70px;
    }
    .item-box {
        margin: 0 15px 15px 0;

    }
    .item-input {
        width: 200px;
    }
    .model-footer-btns{
      margin-top:16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/gold-page/gold-pay-modal.vue